import React from 'react';
import { CalendarIcon, CheckCircleIcon } from 'lucide-react';
const holidays = [{
  name: "New Year's Day",
  date: 'January 1, 2025',
  dayOfWeek: 'Wednesday',
  passed: true,
  icon: '🎆'
}, {
  name: 'Memorial Day',
  date: 'May 26, 2025',
  dayOfWeek: 'Monday',
  passed: false,
  icon: '🇺🇸'
}, {
  name: 'Independence Day',
  date: 'July 4, 2025',
  dayOfWeek: 'Friday',
  passed: false,
  icon: '🎇'
}, {
  name: 'Labor Day',
  date: 'September 1, 2025',
  dayOfWeek: 'Monday',
  passed: false,
  icon: '🛠️'
}, {
  name: 'Thanksgiving Day',
  date: 'November 27, 2025',
  dayOfWeek: 'Thursday',
  passed: false,
  icon: '🦃'
}, {
  name: 'Christmas Day',
  date: 'December 25, 2025',
  dayOfWeek: 'Thursday',
  passed: false,
  icon: '🎄'
}];
export function SwiftHolidays() {
  return <div style={{
    maxWidth: 800,
    margin: '0 auto'
  }} data-id="element-808">
      <div style={{
      marginBottom: 24,
      textAlign: 'center'
    }} data-id="element-809">
        <div style={{
        width: 48,
        height: 48,
        borderRadius: 12,
        background: '#EBF5FB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 16px'
      }} data-id="element-810">
          <CalendarIcon size={24} color="#2B8DC4" data-id="element-811" />
        </div>
        <h2 style={{
        fontSize: 28,
        fontWeight: 900,
        color: '#1A2B3C',
        margin: '0 0 8px',
        fontStyle: 'italic',
        letterSpacing: '-0.04em'
      }} data-id="element-812">
          Swift Holidays
        </h2>
        <p style={{
        fontSize: 14,
        color: '#5A6A8A',
        margin: 0
      }} data-id="element-813">
          Company days off for the 2025 calendar year
        </p>
      </div>

      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      padding: '32px',
      border: '1px solid #E4EAF6',
      borderTopWidth: 4,
      borderTopColor: '#2B8DC4',
      boxShadow: '0 4px 16px rgba(13,27,42,0.06)'
    }} data-id="element-814">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-815">
          {holidays.map((holiday, i) => <div key={i} style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          padding: '16px 20px',
          borderRadius: 12,
          background: holiday.passed ? '#F8FAFC' : '#F4F8FC',
          border: '1px solid #E4EAF6',
          opacity: holiday.passed ? 0.7 : 1
        }} data-id="element-816">
              <div style={{
            fontSize: 24,
            width: 48,
            height: 48,
            borderRadius: 12,
            background: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 4px rgba(13,27,42,0.04)'
          }} data-id="element-817">
                {holiday.icon}
              </div>
              <div style={{
            flex: 1
          }} data-id="element-818">
                <div style={{
              fontSize: 16,
              fontWeight: 900,
              color: '#1A2B3C',
              fontStyle: 'italic',
              letterSpacing: '-0.01em',
              marginBottom: 4
            }} data-id="element-819">
                  {holiday.name}
                </div>
                <div style={{
              fontSize: 13,
              color: '#5A6A8A',
              fontWeight: 500
            }} data-id="element-820">
                  {holiday.date} · {holiday.dayOfWeek}
                </div>
              </div>
              <div data-id="element-821">
                {holiday.passed ? <span style={{
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontSize: 12,
              fontWeight: 800,
              color: '#A0AECB',
              padding: '4px 10px',
              borderRadius: 6,
              background: '#FFFFFF',
              border: '1px solid #E4EAF6'
            }} data-id="element-822">
                    <CheckCircleIcon size={14} data-id="element-823" /> Passed
                  </span> : <span style={{
              fontSize: 12,
              fontWeight: 800,
              color: '#2B8DC4',
              padding: '4px 10px',
              borderRadius: 6,
              background: '#EBF5FB'
            }} data-id="element-824">
                    Upcoming
                  </span>}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}